.topbar {
  position: sticky;
  top: 0;
  z-index: var(--z-sticky);
  display: flex;
  align-items: center;
  gap: var(--s-6);
  min-height: var(--h-topbar);
  padding: var(--s-4) var(--s-8);
  background: var(--surface-card);
  border-bottom: var(--bw-hair) solid var(--border-hair);
  font-family: var(--font-body);
}
.textos {
  flex: 1;
  min-width: 0;
}
.migas {
  display: flex;
  align-items: center;
  gap: var(--s-2);
  margin-bottom: var(--s-1);
  font-size: var(--fs-2xs);
  color: var(--text-muted);
}
.titulo {
  margin: 0;
  font-family: var(--font-display);
  font-size: var(--fs-lg);
  font-weight: var(--fw-semibold);
  letter-spacing: var(--ls-subheading);
  line-height: var(--lh-snug);
  color: var(--text-strong);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.subtitulo {
  font-size: var(--fs-2xs);
  color: var(--text-muted);
}
.acciones {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--s-4);
}

@media (max-width: 767px) {
  .topbar {
    flex-wrap: wrap;
    padding: var(--s-4) var(--s-6);
  }
  .textos {
    flex-basis: 100%;
  }
  .titulo {
    white-space: normal;
  }
  .acciones {
    width: 100%;
  }
}
